module.exports = __webpack_public_path__ + "static/media/hydroponics_shop_nft.892c08fe.webp";